export default __webpack_public_path__ + "static/media/strategy3.fa46eb92.png";